module.exports = __webpack_public_path__ + "common/images/zoomloader.gif";


//////////////////
// WEBPACK FOOTER
// ./Common/images/zoomloader.gif
// module id = 34
// module chunks = 0 1 2 3 4 5